import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, CardTitle, Button, Alert} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {notificationsList} from "../../store/notifications/actions";
import SmallAvatar from "../../components/Common/SmallAvatar";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationsData: [],
      loading: false,
      error: "",
      notificationData: null,
      newModal: false,
    }
    this.refresh = this.refresh.bind(this)
    this.togNew = this.togNew.bind(this)
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    this.props.onNotificationsList({history: this.props.history})
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        notificationsData: this.props.response.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  togNew(data = null) {
    this.setState(prevState => ({
      notificationData: data,
      newModal: !prevState.newModal,
    }))
  }

  render() {
    const messageFormatter = (cell, row) => {
      return (<div style={{whiteSpace: "break-spaces"}}>
        {row.message}
      </div>);
    }
    const typeFormatter = (cell, row) => {
      return (<div>
        {row.type === 0 && <div className="text-success">success</div>}
        {row.type === 1 && <div className="text-info">info</div>}
        {row.type === 2 && <div className="text-warning">warning</div>}
        {row.type === 3 && <div className="text-danger">error</div>}
      </div>);
    }

    const userFormatter = (cell, row) => {
      return (<div>
        {row.user && <SmallAvatar user={row.user} history={this.props.history}/>}
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "title", text: "Title", sort: true,
    }, {
      dataField: "message", text: "Message", sort: true, formatter: messageFormatter,
    }, {
      dataField: "type", text: "Type", sort: true, formatter: typeFormatter,
    }, {
      dataField: "user", text: "User", sort: true, formatter: userFormatter,
    }, {
      dataField: "group", text: "Group", sort: true,
    }, {
      dataField: "created", text: "Created", sort: true,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.notificationsData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.title.toLowerCase().includes(searchText) || row.message.toLowerCase().includes(searchText) || row.created.includes(searchText))
        return true
      return false
    }

    document.title = "Notifications | FileJet";

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={this.props.t("FileJet")}
            breadcrumbItem={this.props.t("Notifications")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.notificationsData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.notificationsData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="8">
                            <div>
                              <Button color="primary" onClick={() => this.togNew({})}>
                                New
                              </Button>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loading && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.error.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.error}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.newModal && <NewModal togModal={this.togNew} refreshParent={this.props.onNotificationsList} notificationData={this.state.notificationData} history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

Notifications.propTypes = {
  response: PropTypes.any,
  onNotificationsList: PropTypes.func,
};

const mapStateToProps = ({Notifications}) => ({
  response: Notifications.responseList,
  loading: Notifications.loadingList,
  error: Notifications.errorList,
});

const mapDispatchToProps = dispatch => ({
  onNotificationsList: data => dispatch(notificationsList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Notifications));
